<template>
    <div>
        <p
            class="push-up"
            v-html="modalContent.HeadLine"
        />
        <changes />
        <p>
            <strong v-html="modalContent.WarningMessagesHeadline" />
        </p>
        <p
            v-if="modalContent.ShowAdditionalBasketProductInformationText"
            class="text-warning"
            v-html="modalContent.AdditionalBasketProductInformationText"
        />
        <div
            v-if="showWarningMessages"
            class="push-up"
        >
            <p
                v-for="(warningMessage, index) in warningMessageList"
                :key="'warning-message-' + index"
                class="text-warning"
                data-test="policy-warning-message"
                v-html="warningMessage"
            />
        </div>
        <p
            class="text-warning"
            v-html="claimsNoticeClaimsText"
        />
        <p
            v-if="hasPaymentTermsNoticeText"
            class="text-warning"
            data-test-policy-paymentterms-notice-text
            v-html="modalContent.PaymentTermsNoticeText"
        />
        <p
            v-if="showAddRiskText"
            class="text-warning"
            data-test-added-cover-disclaimer
            v-html="modalContent.AddedCoverageDisclaimer"
        />
        <p
            class="push-up"
            v-html="dateLineText"
        />
        <hr class="big-margin">
        <price-line
            :price="originalprice"
            :label="modalContent.CurrentPriceLabel"
            :payment-period-label="modalContent.PaymentPeriodLabel"
        />
        <price-line
            class="push-up"
            :price="price"
            :label="modalContent.NewPriceLabel"
            :payment-period-label="modalContent.PaymentPeriodLabel"
            :emphasize="true"
        />
    </div>
</template>
<script>
import Changes from "../Basket/Changes.vue";
import PriceLine from "../Basket/PriceLine.vue";

export default {
    name: "ConfirmSaveProposalModalContent",
    components: {
        Changes,
        PriceLine,
    },
    data() {
        return {
            showAddRiskText: false,
        };
    },
    computed: {
        modalContent() {
            return this.$store.state.policy.modalData.content;
        },
        originalprice() {
            return this.$store.state.policy.initialVueModel.Price.PriceFormatted;
        },
        price() {
            return this.$store.state.policy.price;
        },
        effectivedate() {
            return this.$store.getters["policy/effectiveDate"];
        },
        dateLineText() {
            return this.modalContent.DateLine.replace(
                "{effectivedate}",
                this.effectivedate
            );
        },
        claimsNoticeClaimsText() {
            return this.modalContent.ClaimsNotice;
        },
        warningMessageList() {
            return this.$store.getters["policy/warningMessageList"];
        },
        showWarningMessages() {
            return this.warningMessageList.length > 0;
        },
        hasPaymentTermsNoticeText() {
            return (
                this.modalContent.PaymentTermsNoticeText !== null &&
        this.modalContent.PaymentTermsNoticeText !== ""
            );
        },
        coverChanges() {
            return this.$store.getters["policy/getChangedCovers"];
        },
    },
    watch: {
        coverChanges(val) {
            this.checkForAddedCover(val);
        },
    },
    mounted() {
        this.$store.dispatch(
            "policy/registerEvent",
            "policy-view-show-confirmation-modal"
        );
        this.checkForAddedCover(this.coverChanges);
    },
    methods: {
        checkForAddedCover(arr) {
            if (Array.isArray(arr)) {
                let i = 0;
                for (i; i <= arr.length; i++) {
                    const value = arr[i]?.Value ?? "";
                    if (value === "Tilvalgt" || value.includes("tilvalgt")) {
                        this.showAddRiskText = true;
                        break;
                    } else {
                        this.showAddRiskText = false;
                    }
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "node_modules/foundation-sites/scss/util/util";

.big-margin {
  margin: rem-calc(35px) 0;
}
</style>
